import {BehaviorSubject, Observable} from 'rxjs';
import {DataSource} from '@angular/cdk/table';
import {User} from '../models/user';
import {UserService} from '../../services/api/user.service';
import {CollectionViewer} from '@angular/cdk/collections';
import {UserFilters} from '../models/filters/user-filters';

export class UsersDataSource implements DataSource<User> {

  private usersSubject = new BehaviorSubject<User[]>([]);
  private totalElementsSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public totalElements$ = this.totalElementsSubject.asObservable();
  public loading$ = this.loadingSubject.asObservable();

  constructor(
    private userService: UserService,
  ) {
  }

  connect(collectionViewer: CollectionViewer): Observable<User[]> {
    return this.usersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.usersSubject.complete();
    this.totalElementsSubject.complete();
    this.loadingSubject.complete();
  }

  loadUsers(
    filters: UserFilters,
    sort: any[], pageSize: number, pageNumber: number,
  ): void {

    this.loadingSubject.next(true);

    this.userService.searchUsers(filters, sort, pageSize, pageNumber)
      .then(page => {
        this.usersSubject.next(page.content);
        this.totalElementsSubject.next(page.totalElements);
      })
      .catch(error => {
        this.usersSubject.next([]);
        this.totalElementsSubject.next(0);
      })
      .finally(() => {
        this.loadingSubject.next(false);
      });
  }

  insertUser(user: User): void {
    this.usersSubject.next([user, ...this.usersSubject.getValue()]);
  }

}
